import { subDays } from 'date-fns';
import { local } from 'common/js/storage';

export const fireEvent = (eventName, detail) => {
  const event = new CustomEvent(eventName, {
    detail,
  });
  document.dispatchEvent(event);
};

export const STORAGE_KEY = 'abandonedCartModal';

export const getStorage = () => {
  let parsed;

  try {
    parsed = JSON.parse(local.getItem(STORAGE_KEY)) || [];
  } catch (error) {
    parsed = [];
  }

  return parsed;
};

export const removeOutDated = () => {
  const existingData = getStorage();
  const aWeekAgo = subDays(new Date(), 7).getTime();
  const validData = existingData.filter(
    ({ createdAt }) => createdAt > aWeekAgo
  );

  local.setItem(STORAGE_KEY, JSON.stringify(validData));
};

export const storeModalState = (bookingId) =>
  local.setItem(
    STORAGE_KEY,
    JSON.stringify([
      ...getStorage(),
      {
        id: bookingId,
        createdAt: Date.now(),
      },
    ])
  );

export const inStorage = (bookingId) => {
  if (!bookingId) {
    return false;
  }

  const existingData = getStorage();

  return Boolean(existingData.find(({ id }) => id === bookingId));
};

export const parsePassengerObject = ({ passengers, types }) =>
  types.reduce((acc, type) => {
    const key = type.name;
    const value = passengers[type.id];
    acc[key] = value || 0;
    return acc;
  }, {});
